export default __webpack_public_path__ + "static/media/thank.301bcf68.mp3";